import { Fragment } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '../Text';
import {
	StyledCategory,
	StyledNewDot,
	StyledNewShadow,
} from './ShopCategory.styled';

const ShopCategory = ({
	name,
	icon,
	onClick,
	isActive,
	isNew,
	bgColor,
	disabled,
	...props
}: {
	name: string;
	icon: string;
	onClick: () => void;
	isActive?: boolean;
	isNew?: boolean;
	bgColor?: string;
	disabled?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledCategory
			$active={isActive}
			onClick={() => {
				onClick();
				playSound(Sound.ClickButton);
			}}
			$bgColor={bgColor}
			draggable={false}
			$disabled={disabled}
			{...props}
			onMouseEnter={(e) => {
				if (disabled) {
					return;
				}

				props?.onMouseEnter?.(e);
				playSound(Sound.LinkCursor);
			}}
		>
			{isNew && (
				<Fragment>
					<StyledNewShadow />
					<StyledNewDot />
				</Fragment>
			)}
			<img src={icon} draggable={false} />
			<Text>{name}</Text>
		</StyledCategory>
	);
};

export { ShopCategory };
